import { createContext, useContext, useState } from "react";

const Context = createContext([]);

export function GameProvider({ children }) {
  let hasStarted = false;
  let disabled = [];
  const [data, setData] = useState({
    hasStarted,
    disabled
  });
  function updateData(update){
    const l = {...data,...update};
    setData(l);
  }
  return (
	<Context.Provider value={[data, updateData]}>
		{children}
	</Context.Provider>
  );
}

export function useLayoutContext() {
  return useContext(Context);
}